module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div style=\'width:790px; height: 500px;\' id=\'street-view\'></div>\n';

}
return __p
}